var render = function render(_c,_vm){return _c('button',{staticClass:"btn_menu btn-menu-dark",attrs:{"type":"button"},on:{"click":_vm.props.onClick}},[_c('span',{staticClass:"tree-lines-first"}),_c('span',{staticClass:"tree-lines-middle"}),_c('span',{staticClass:"tree-lines-last"})])
}
var staticRenderFns = []

export { render, staticRenderFns }